/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesPriceListResponseDto } from '../../models/sales-price-list-response-dto';

export interface PriceListsControllerFindAllByTenant$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * Optional category ID to filter price lists
 */
  categoryId?: string;
}

export function priceListsControllerFindAllByTenant(http: HttpClient, rootUrl: string, params: PriceListsControllerFindAllByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesPriceListResponseDto>>> {
  const rb = new SalesRequestBuilder(rootUrl, priceListsControllerFindAllByTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('categoryId', params.categoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<Array<SalesPriceListResponseDto>>;
    })
  );
}

priceListsControllerFindAllByTenant.PATH = '/o2-sales/price-lists/{tenant}';
